export enum CounterpartySource {
    MANUAL = "manual",
    RAMP = "ramp",
    STRIPE = "stripe",
    MERCURY = "mercury",
    QUICKBOOKS = "quickbooks",
    BILLCOM = "billcom",
    ENRICHMENT = "enrichment",
}

export const INTEGRATION_COUNTERPARTY_SOURCES: CounterpartySource[] = [
    CounterpartySource.RAMP,
    CounterpartySource.STRIPE,
    CounterpartySource.MERCURY,
    CounterpartySource.QUICKBOOKS,
    CounterpartySource.BILLCOM,
];

export const INTEGRATION_COUNTERPARTY_SOURCES_SQL =
    INTEGRATION_COUNTERPARTY_SOURCES.map((s) => `'${s}'`).join(", ");

export enum TinType {
    SSN = "SSN",
    EIN = "EIN",
}

export enum TinSource {
    MANUAL = "MANUAL",
    W9_EXTRACTION = "W9_EXTRACTION",
    MERGE = "MERGE",
}

export type {
    CounterpartySchema as Counterparty,
    CounterpartyRowSchema as CounterpartyRow,
} from "../schemas/counterparty.schema";

export enum FederalTaxClassification {
    INDIVIDUAL = "individual",
    PARTNERSHIP = "partnership",
    C_CORP = "c_corp",
    S_CORP = "s_corp",
    TRUST_ESTATE = "trust_estate",
    LLC_PARTNERSHIP = "llc_partnership",
    LLC_C_CORP = "llc_c_corp",
    LLC_S_CORP = "llc_s_corp",
    OTHER = "other",
}

export const CORPORATE_FEDERAL_TAX_CLASSIFICATIONS: FederalTaxClassification[] =
    [
        FederalTaxClassification.C_CORP,
        FederalTaxClassification.S_CORP,
        FederalTaxClassification.LLC_C_CORP,
        FederalTaxClassification.LLC_S_CORP,
    ];

export const FEDERAL_TAX_CLASSIFICATION_LABELS: Record<
    FederalTaxClassification,
    string
> = {
    [FederalTaxClassification.INDIVIDUAL]:
        "Individual / sole proprietor / single-member LLC",
    [FederalTaxClassification.PARTNERSHIP]: "Partnership",
    [FederalTaxClassification.C_CORP]: "C corporation",
    [FederalTaxClassification.S_CORP]: "S corporation",
    [FederalTaxClassification.TRUST_ESTATE]: "Trust / estate",
    [FederalTaxClassification.LLC_PARTNERSHIP]: "LLC (partnership)",
    [FederalTaxClassification.LLC_C_CORP]: "LLC (C corporation)",
    [FederalTaxClassification.LLC_S_CORP]: "LLC (S corporation)",
    [FederalTaxClassification.OTHER]: "Other",
};

const FEDERAL_TAX_CLASSIFICATION_UNSPECIFIED_LABEL = "Not specified";

export interface FederalTaxClassificationOption {
    value: FederalTaxClassification | null;
    label: string;
}

export const FEDERAL_TAX_CLASSIFICATION_OPTIONS: FederalTaxClassificationOption[] =
    [
        {
            value: null,
            label: FEDERAL_TAX_CLASSIFICATION_UNSPECIFIED_LABEL,
        },
        ...Object.values(FederalTaxClassification).map((value) => ({
            value,
            label: FEDERAL_TAX_CLASSIFICATION_LABELS[value],
        })),
    ];

export const getFederalTaxClassificationLabel = (
    classification: FederalTaxClassification | null | undefined,
): string => {
    if (!classification) {
        return FEDERAL_TAX_CLASSIFICATION_UNSPECIFIED_LABEL;
    }

    return FEDERAL_TAX_CLASSIFICATION_LABELS[classification] ?? classification;
};
